import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { IEffectItemStore } from '../../../../types/effects/effectsStoreInterface';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../../i18n';
import { SideBarDeleteActionWithPopup } from '../../../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';
import { useDeleteEffectMutation } from '../../../../services/effects/effectsStoreService';

interface MultipleDetailsEffectStoreProps {
  effects: IEffectItemStore[];
  closeSideBar: () => void;
  reloadTable: () => void;
}

export const MultipleDetailsEffectStore = ({
  effects,
  closeSideBar,
  reloadTable
}: MultipleDetailsEffectStoreProps) => {
  const [deleteEffects, { isSuccess: successDelete }] =
    useDeleteEffectMutation();

  const deleteEffect = () => {
    deleteEffects(effects.map((effect) => effect.id));
  };

  useEffect(() => {
    if (successDelete) {
      toast.success(Strings.effects.deleteEffectSuccess);
      closeSideBar();
      reloadTable();
    }
  }, [successDelete]);

  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>
          {Strings.effects.multipleDetailsEffect}
        </StyledTitleSideBar>
        <SideBarDeleteActionWithPopup
          onDelete={() => deleteEffect()}
          titleConfirmation={Strings.effects.deleteEffect}
          textConfirmation={Strings.common.thisActionIsIrreversible}
          textIcon={Strings.effects.deleteEffect}
        />
      </StyledContainerItems>
      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => {
            closeSideBar();
          }}
        >
          {Strings.common.cancel}
        </button>
      </StyledContainerFooterSideBar>
    </>
  );
};
